import { Form } from "@themesberg/react-bootstrap";
import styled  , {keyframes, css}from "styled-components";

const StyledSelect = styled(Form.Select)`
  option:first-child {
    display: none;
  }
`;

const ActionButton = styled.button`
  background: transparent;
  border: none;
  color: #9155fd;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgb(145, 85, 253, 0.1);
    color: #9155fd;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    color: #a9a9a9;
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;

    &:hover {
      background-color: transparent;
      transform: none;
    }
  }

  i {
    font-size: 1rem;
  }
`;

const TableCell = styled.td`
  padding: 0.75rem 1rem !important;
  max-width: 200px;

  &.pickup-location {
    padding-right: 1.5rem !important;
  }

  &.special-instructions {
    padding-left: 1.5rem !important;
  }
`;

const StyledRow = styled.tr`
  transition: background-color 0.2s ease;

  & .status-span {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 0.85rem;
    line-height: 1.5;
    transition: all 0.2s ease;
  }

  &:hover {
    background-color: ${(props) => {
    switch (props.status) {
      case 0:
        return "rgb(226, 233, 255)";
      case 1:
        return "rgb(226, 255, 228)";
      case 2:
        return "rgb(255, 228, 226)";
      case 3:
        return "rgb(255, 250, 226)";
      case 4:
        return "rgb(226, 255, 241)";
      default:
        return "";
    }
  }} !important;


    &:hover .status-span-0 {
      background-color: rgb(224, 232, 255) !important;
    }

    &:hover .status-span-1 {
      background-color: rgb(226, 255, 228) !important;
    }

    &:hover .status-span-2 {
      background-color: rgb(255, 228, 226) !important;
    }

    &:hover .status-span-3 {
      background-color: rgb(255, 250, 226) !important;
    }

    &:hover .status-span-4 {
      background-color: rgb(226, 255, 241) !important;
    }
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Styled component for the crypto icon
const CryptoIcon = styled.i`
  display: inline-block;
  ${({ spinning }) =>
    spinning &&
    css`
      animation: ${spin} 1s linear infinite;
    `}
`;

export { StyledSelect, ActionButton, TableCell, StyledRow , CryptoIcon};
